import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ElementRef,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'ut-image-lightbox',
  imports: [],
  templateUrl: './image-lightbox.component.html',
  styleUrls: ['./image-lightbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageLightboxComponent {
  src = '';
  alt = '';

  @ViewChild('dialog') private dialogRef!: ElementRef<HTMLDialogElement>;

  private triggerElement: HTMLElement | null = null;

  constructor(private cdr: ChangeDetectorRef) {}

  open(src: string, alt: string, trigger?: HTMLElement): void {
    this.src = src;
    this.alt = alt;
    this.triggerElement = trigger || null;
    this.cdr.detectChanges();
    this.dialogRef.nativeElement.showModal();
  }

  close(): void {
    this.dialogRef.nativeElement.close();
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === this.dialogRef.nativeElement) {
      this.close();
    }
  }

  onDialogClose(): void {
    // Deferred to run after the browser's native focus restoration
    if (this.triggerElement) {
      const el = this.triggerElement;
      this.triggerElement = null;
      setTimeout(() => el.focus({ preventScroll: true }));
    }
  }
}
